(() => {
  if (window.extroCartAjaxLoaded) return;
  window.extroCartAjaxLoaded = true;

  const sectionSelector = '.shopify-section--main-cart';
  let requestInFlight = false;
  let stickyObserver = null;

  function cartSection() {
    return document.querySelector('.extro-cart-rows')?.closest('.shopify-section') || document.querySelector(sectionSelector);
  }

  function lineFrom(target) {
    return target.closest('tr[data-cart-line]');
  }

  function showLineError(line, message) {
    const error = line?.querySelector('.line-item__cart-error');
    if (!error) return;
    error.textContent = message || 'Non siamo riusciti ad aggiornare questo prodotto. Riprova tra poco.';
    error.hidden = false;
  }

  function setLineBusy(line, busy) {
    if (!line) return;
    line.classList.toggle('is-updating', busy);
    line.querySelectorAll('a, button, input').forEach((control) => {
      if (busy) {
        control.dataset.extroWasDisabled = String(control.disabled === true);
        control.setAttribute('aria-disabled', 'true');
        if ('disabled' in control) control.disabled = true;
      } else {
        control.removeAttribute('aria-disabled');
        if ('disabled' in control && control.dataset.extroWasDisabled !== 'true') control.disabled = false;
        delete control.dataset.extroWasDisabled;
      }
    });
  }

  function restoreQuantity(line) {
    const input = line?.querySelector('.quantity-selector__input[data-current-quantity]');
    if (!input) return;
    input.value = input.dataset.currentQuantity;
  }

  function parseChangeUrl(url) {
    const parsed = new URL(url, window.location.origin);
    return {
      line: parsed.searchParams.get('line'),
      id: parsed.searchParams.get('id'),
      quantity: Number(parsed.searchParams.get('quantity'))
    };
  }

  function replaceCartSection(html) {
    const current = cartSection();
    if (!current || !html) return false;
    const rendered = new DOMParser().parseFromString(html, 'text/html').getElementById(current.id);
    if (!rendered) return false;
    const outfitOpen = current.querySelector('extro-cart-outfit details')?.open;
    current.innerHTML = rendered.innerHTML;
    if (outfitOpen) current.querySelector('extro-cart-outfit details')?.setAttribute('open', '');
    document.dispatchEvent(new CustomEvent('extro:cart-section:updated', { bubbles: true }));
    setupStickyCheckout();
    return true;
  }

  async function updateCart({ line, id, quantity, row }) {
    if (requestInFlight || !Number.isFinite(quantity)) return;

    requestInFlight = true;
    const input = row?.querySelector('.quantity-selector__input[data-current-quantity]');
    const previousQuantity = input?.dataset.currentQuantity;
    const error = row?.querySelector('.line-item__cart-error');
    if (error) error.hidden = true;
    setLineBusy(row, true);

    try {
      const sectionId = cartSection()?.id.replace('shopify-section-', '') || 'main-cart';
      const body = { quantity, sections: [sectionId], sections_url: location.pathname };
      if (line) body.line = line;
      if (id) body.id = id;

      const response = await fetch(`${window.themeVariables.routes.cartChangeUrl}.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });

      const payload = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(payload.description || payload.message || 'Aggiornamento non riuscito.');
      }

      if (!replaceCartSection(payload.sections?.[sectionId])) {
        location.reload();
        return;
      }

      document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
        bubbles: true,
        detail: { cart: payload }
      }));
    } catch (errorMessage) {
      if (input && previousQuantity != null) input.value = previousQuantity;
      restoreQuantity(row);
      showLineError(row, errorMessage.message);
      document.dispatchEvent(new CustomEvent('extro:cart-error', {
        bubbles: true,
        detail: {
          message: errorMessage.message,
          line: row?.dataset.cartLine
        }
      }));
    } finally {
      setLineBusy(row, false);
      requestInFlight = false;
    }
  }

  function onClick(event) {
    const link = event.target.closest('.line-item .quantity-selector__button[href], .line-item__remove-button[href]');
    if (!link || !cartSection()) return;

    const row = lineFrom(link);
    if (!row || requestInFlight) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    const change = link.classList.contains('line-item__remove-button')
      ? { line: row.dataset.cartLine, quantity: 0 }
      : parseChangeUrl(link.href);

    updateCart({ ...change, row });
  }

  function onChange(event) {
    const input = event.target.closest('.line-item .quantity-selector__input[data-line]');
    if (!input || !cartSection()) return;

    const row = lineFrom(input);
    event.preventDefault();
    event.stopImmediatePropagation();

    if (!row || requestInFlight) {
      restoreQuantity(row);
      return;
    }

    updateCart({
      line: input.dataset.line,
      quantity: Number(input.value),
      row
    });
  }

  function setupStickyCheckout() {
    stickyObserver?.disconnect();

    const mainButton = document.getElementById('main-checkout-button');
    const stickyBar = document.getElementById('cart-sticky-checkout-mobile');
    const mobileBreakpoint = window.matchMedia('(max-width: 740px)');

    if (!mainButton || !stickyBar) return;

    const hide = () => {
      stickyBar.classList.remove('is-visible');
      stickyBar.setAttribute('aria-hidden', 'true');
    };

    const show = () => {
      stickyBar.classList.add('is-visible');
      stickyBar.setAttribute('aria-hidden', 'false');
    };

    stickyObserver = new IntersectionObserver((entries) => {
      if (!mobileBreakpoint.matches) {
        hide();
        return;
      }
      entries.forEach((entry) => entry.isIntersecting ? hide() : show());
    }, { threshold: 0.01 });

    stickyObserver.observe(mainButton);
  }

  document.addEventListener('click', onClick, true);
  document.addEventListener('change', onChange, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupStickyCheckout, { once: true });
  } else {
    setupStickyCheckout();
  }
})();
